var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageModeratorsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_2479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 8.90015C22.7585 8.90015 22.8337 8.97528 22.8337 9.06714V22.5671H22.4997V9.23315H11.1667V8.90015H22.6667Z",
    fill: "#F56565",
    stroke: "#F56565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 11.5669H19.9997C20.0915 11.5669 20.1667 11.642 20.1667 11.7339V23.7339C20.1665 23.8256 20.0914 23.8999 19.9997 23.8999H9.33366C9.24191 23.8999 9.16684 23.8256 9.16667 23.7339V11.7339C9.16667 11.642 9.2418 11.5669 9.33366 11.5669ZM10.8337 21.5669H15.8337V19.2339H10.8337V21.5669ZM10.8337 18.8999H18.4997V16.5669H10.8337V18.8999ZM10.8337 16.2339H18.4997V13.8999H10.8337V16.2339Z",
    fill: "#F56565",
    stroke: "#F56565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_2479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8.40015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageModeratorsIcon);
export default __webpack_public_path__ + "static/media/manage-moderators-icon.1e85a2184e29df4677fa4f541d302629.svg";
export { ForwardRef as ReactComponent };